module.exports = __webpack_public_path__ + "img/input-number.10a4a0a3.svg";